/* eslint-disable no-restricted-imports */
import { Flex, Tag } from "@chakra-ui/react";
import { GenericError } from "src/components/Feedback/GenericError";
import * as AF from "src/types/formTemplate";
import { useEditFormTemplateContext } from "../../../context";

type Props = { question: AF.V3.Question };

export const VerificationTag: React.FC<Props> = ({ question }) => {
  const { state } = useEditFormTemplateContext();

  if (!question.formVerificationId) {
    return null;
  }

  const verification = state
    .get("draft")
    .verifications?.find((v) => v.id === question.formVerificationId);

  if (verification === undefined) {
    return <GenericError />;
  }

  return (
    <Flex direction="row">
      <Tag size="sm">{verification.label} verification</Tag>
    </Flex>
  );
};

export function hasVerificationTags(question: AF.V3.Question): boolean {
  return VerificationTag({ question }) !== null;
}
